export const schedule = [
  {
    "Match No": 1,
    "Match Day": 1,
    Date: "2025-03-22T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Royal Challengers Bengaluru",
    Venue: "Kolkata",
  },
  {
    "Match No": 2,
    "Match Day": 2,
    Date: "2025-03-23T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Rajasthan Royals",
    Venue: "Hyderabad",
  },
  {
    "Match No": 3,
    "Match Day": 2,
    Date: "2025-03-23T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Mumbai Indians",
    Venue: "Chennai",
  },
  {
    "Match No": 4,
    "Match Day": 3,
    Date: "2025-03-24T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Lucknow Super Giants",
    Venue: "Visakhapatnam",
  },
  {
    "Match No": 5,
    "Match Day": 4,
    Date: "2025-03-25T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Gujarat Titans",
    Away: "Punjab Kings",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 6,
    "Match Day": 5,
    Date: "2025-03-26T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Kolkata Knight Riders",
    Venue: "Guwahati",
  },
  {
    "Match No": 7,
    "Match Day": 6,
    Date: "2025-03-27T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Lucknow Super Giants",
    Venue: "Hyderabad",
  },
  {
    "Match No": 8,
    "Match Day": 7,
    Date: "2025-03-28T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Royal Challengers Bengaluru",
    Venue: "Chennai",
  },
  {
    "Match No": 9,
    "Match Day": 8,
    Date: "2025-03-29T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Gujarat Titans",
    Away: "Mumbai Indians",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 10,
    "Match Day": 9,
    Date: "2025-03-30T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Delhi Capitals",
    Away: "Sunrisers Hyderabad",
    Venue: "Visakhapatnam",
  },
  {
    "Match No": 11,
    "Match Day": 9,
    Date: "2025-03-30T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Chennai Super Kings",
    Venue: "Guwahati",
  },
  {
    "Match No": 12,
    "Match Day": 10,
    Date: "2025-03-31T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Kolkata Knight Riders",
    Venue: "Mumbai",
  },
  {
    "Match No": 13,
    "Match Day": 11,
    Date: "2025-04-01T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Punjab Kings",
    Venue: "Lucknow",
  },
  {
    "Match No": 14,
    "Match Day": 12,
    Date: "2025-04-02T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Gujarat Titans",
    Venue: "Bengaluru",
  },
  {
    "Match No": 15,
    "Match Day": 13,
    Date: "2025-04-03T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Sunrisers Hyderabad",
    Venue: "Kolkata",
  },
  {
    "Match No": 16,
    "Match Day": 14,
    Date: "2025-04-04T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Mumbai Indians",
    Venue: "Lucknow",
  },
  {
    "Match No": 17,
    "Match Day": 15,
    Date: "2025-04-05T00:00:00.000",
    Day: "Sat",
    Start: "3:30 PM",
    Home: "Chennai Super Kings",
    Away: "Delhi Capitals",
    Venue: "Chennai",
  },
  {
    "Match No": 18,
    "Match Day": 15,
    Date: "2025-04-05T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Punjab Kings",
    Away: "Rajasthan Royals",
    Venue: "New Chandigarh",
  },
  {
    "Match No": 19,
    "Match Day": 16,
    Date: "2025-04-06T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Lucknow Super Giants",
    Venue: "Kolkata",
  },
  {
    "Match No": 20,
    "Match Day": 16,
    Date: "2025-04-06T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Gujarat Titans",
    Venue: "Hyderabad",
  },
  {
    "Match No": 21,
    "Match Day": 17,
    Date: "2025-04-07T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Royal Challengers Bengaluru",
    Venue: "Mumbai",
  },
  {
    "Match No": 22,
    "Match Day": 18,
    Date: "2025-04-08T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Punjab Kings",
    Away: "Chennai Super Kings",
    Venue: "New Chandigarh",
  },
  {
    "Match No": 23,
    "Match Day": 19,
    Date: "2025-04-09T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Gujarat Titans",
    Away: "Rajasthan Royals",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 24,
    "Match Day": 20,
    Date: "2025-04-10T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Delhi Capitals",
    Venue: "Bengaluru",
  },
  {
    "Match No": 25,
    "Match Day": 21,
    Date: "2025-04-11T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Kolkata Knight Riders",
    Venue: "Chennai",
  },
  {
    "Match No": 26,
    "Match Day": 22,
    Date: "2025-04-12T00:00:00.000",
    Day: "Sat",
    Start: "3:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Gujarat Titans",
    Venue: "Lucknow",
  },
  {
    "Match No": 27,
    "Match Day": 22,
    Date: "2025-04-12T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Punjab Kings",
    Venue: "Hyderabad",
  },
  {
    "Match No": 28,
    "Match Day": 23,
    Date: "2025-04-13T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Rajasthan Royals",
    Away: "Royal Challengers Bengaluru",
    Venue: "Jaipur",
  },
  {
    "Match No": 29,
    "Match Day": 23,
    Date: "2025-04-13T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Mumbai Indians",
    Venue: "Delhi",
  },
  {
    "Match No": 30,
    "Match Day": 24,
    Date: "2025-04-14T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Chennai Super Kings",
    Venue: "Lucknow",
  },
  {
    "Match No": 31,
    "Match Day": 25,
    Date: "2025-04-15T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Punjab Kings",
    Away: "Kolkata Knight Riders",
    Venue: "New Chandigarh",
  },
  {
    "Match No": 32,
    "Match Day": 26,
    Date: "2025-04-16T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Rajasthan Royals",
    Venue: "Delhi",
  },
  {
    "Match No": 33,
    "Match Day": 27,
    Date: "2025-04-17T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Sunrisers Hyderabad",
    Venue: "Mumbai",
  },
  {
    "Match No": 34,
    "Match Day": 28,
    Date: "2025-04-18T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Punjab Kings",
    Venue: "Bengaluru",
  },
  {
    "Match No": 35,
    "Match Day": 29,
    Date: "2025-04-19T00:00:00.000",
    Day: "Sat",
    Start: "3:30 PM",
    Home: "Gujarat Titans",
    Away: "Delhi Capitals",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 36,
    "Match Day": 29,
    Date: "2025-04-19T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Lucknow Super Giants",
    Venue: "Jaipur",
  },
  {
    "Match No": 37,
    "Match Day": 30,
    Date: "2025-04-20T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Punjab Kings",
    Away: "Royal Challengers Bengaluru",
    Venue: "New Chandigarh",
  },
  {
    "Match No": 38,
    "Match Day": 30,
    Date: "2025-04-20T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Chennai Super Kings",
    Venue: "Mumbai",
  },
  {
    "Match No": 39,
    "Match Day": 31,
    Date: "2025-04-21T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Gujarat Titans",
    Venue: "Kolkata",
  },
  {
    "Match No": 40,
    "Match Day": 32,
    Date: "2025-04-22T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Delhi Capitals",
    Venue: "Lucknow",
  },
  {
    "Match No": 41,
    "Match Day": 33,
    Date: "2025-04-23T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Mumbai Indians",
    Venue: "Hyderabad",
  },
  {
    "Match No": 42,
    "Match Day": 34,
    Date: "2025-04-24T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Rajasthan Royals",
    Venue: "Bengaluru",
  },
  {
    "Match No": 43,
    "Match Day": 35,
    Date: "2025-04-25T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Sunrisers Hyderabad",
    Venue: "Chennai",
  },
  {
    "Match No": 44,
    "Match Day": 36,
    Date: "2025-04-26T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Punjab Kings",
    Venue: "Kolkata",
  },
  {
    "Match No": 45,
    "Match Day": 37,
    Date: "2025-04-27T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Mumbai Indians",
    Away: "Lucknow Super Giants",
    Venue: "Mumbai",
  },
  {
    "Match No": 46,
    "Match Day": 37,
    Date: "2025-04-27T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Royal Challengers Bengaluru",
    Venue: "Delhi",
  },
  {
    "Match No": 47,
    "Match Day": 38,
    Date: "2025-04-28T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Gujarat Titans",
    Venue: "Jaipur",
  },
  {
    "Match No": 48,
    "Match Day": 39,
    Date: "2025-04-29T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Kolkata Knight Riders",
    Venue: "Delhi",
  },
  {
    "Match No": 49,
    "Match Day": 40,
    Date: "2025-04-30T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Punjab Kings",
    Venue: "Chennai",
  },
  {
    "Match No": 50,
    "Match Day": 41,
    Date: "2025-05-01T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Mumbai Indians",
    Venue: "Jaipur",
  },
  {
    "Match No": 51,
    "Match Day": 42,
    Date: "2025-05-02T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Gujarat Titans",
    Away: "Sunrisers Hyderabad",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 52,
    "Match Day": 43,
    Date: "2025-05-03T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Chennai Super Kings",
    Venue: "Bengaluru",
  },
  {
    "Match No": 53,
    "Match Day": 44,
    Date: "2025-05-04T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Rajasthan Royals",
    Venue: "Kolkata",
  },
  {
    "Match No": 54,
    "Match Day": 44,
    Date: "2025-05-04T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Punjab Kings",
    Away: "Lucknow Super Giants",
    Venue: "Dharamshala",
  },
  {
    "Match No": 55,
    "Match Day": 45,
    Date: "2025-05-05T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Delhi Capitals",
    Venue: "Hyderabad",
  },
  {
    "Match No": 56,
    "Match Day": 46,
    Date: "2025-05-06T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Gujarat Titans",
    Venue: "Mumbai",
  },
  {
    "Match No": 57,
    "Match Day": 47,
    Date: "2025-05-07T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Kolkata Knight Riders",
    Away: "Chennai Super Kings",
    Venue: "Kolkata",
  },
  {
    "Match No": 58,
    "Match Day": 48,
    Date: "2025-05-08T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Punjab Kings",
    Away: "Delhi Capitals",
    Venue: "Dharamshala",
  },
  {
    "Match No": 59,
    "Match Day": 49,
    Date: "2025-05-09T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Royal Challengers Bengaluru",
    Venue: "Lucknow",
  },
  {
    "Match No": 60,
    "Match Day": 50,
    Date: "2025-05-10T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Sunrisers Hyderabad",
    Away: "Kolkata Knight Riders",
    Venue: "Hyderabad",
  },
  {
    "Match No": 61,
    "Match Day": 51,
    Date: "2025-05-11T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Punjab Kings",
    Away: "Mumbai Indians",
    Venue: "Dharamshala",
  },
  {
    "Match No": 62,
    "Match Day": 51,
    Date: "2025-05-11T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Delhi Capitals",
    Away: "Gujarat Titans",
    Venue: "Delhi",
  },
  {
    "Match No": 63,
    "Match Day": 52,
    Date: "2025-05-12T00:00:00.000",
    Day: "Mon",
    Start: "7:30 PM",
    Home: "Chennai Super Kings",
    Away: "Rajasthan Royals",
    Venue: "Chennai",
  },
  {
    "Match No": 64,
    "Match Day": 53,
    Date: "2025-05-13T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Sunrisers Hyderabad",
    Venue: "Bengaluru",
  },
  {
    "Match No": 65,
    "Match Day": 54,
    Date: "2025-05-14T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: "Gujarat Titans",
    Away: "Lucknow Super Giants",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 66,
    "Match Day": 55,
    Date: "2025-05-15T00:00:00.000",
    Day: "Thu",
    Start: "7:30 PM",
    Home: "Mumbai Indians",
    Away: "Delhi Capitals",
    Venue: "Mumbai",
  },
  {
    "Match No": 67,
    "Match Day": 56,
    Date: "2025-05-16T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: "Rajasthan Royals",
    Away: "Punjab Kings",
    Venue: "Jaipur",
  },
  {
    "Match No": 68,
    "Match Day": 57,
    Date: "2025-05-17T00:00:00.000",
    Day: "Sat",
    Start: "7:30 PM",
    Home: "Royal Challengers Bengaluru",
    Away: "Kolkata Knight Riders",
    Venue: "Bengaluru",
  },
  {
    "Match No": 69,
    "Match Day": 58,
    Date: "2025-05-18T00:00:00.000",
    Day: "Sun",
    Start: "3:30 PM",
    Home: "Gujarat Titans",
    Away: "Chennai Super Kings",
    Venue: "Ahmedabad",
  },
  {
    "Match No": 70,
    "Match Day": 58,
    Date: "2025-05-18T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: "Lucknow Super Giants",
    Away: "Sunrisers Hyderabad",
    Venue: "Lucknow",
  },
  {
    "Match No": 71,
    "Match Day": 60,
    Date: "2025-05-20T00:00:00.000",
    Day: "Tue",
    Start: "7:30 PM",
    Home: null,
    Away: "Qualifier 1",
    Venue: "Hyderabad",
  },
  {
    "Match No": 72,
    "Match Day": 61,
    Date: "2025-05-21T00:00:00.000",
    Day: "Wed",
    Start: "7:30 PM",
    Home: null,
    Away: "Eliminator",
    Venue: "Hyderabad",
  },
  {
    "Match No": 73,
    "Match Day": 63,
    Date: "2025-05-23T00:00:00.000",
    Day: "Fri",
    Start: "7:30 PM",
    Home: null,
    Away: "Qualifier 2",
    Venue: "Kolkata",
  },
  {
    "Match No": 74,
    "Match Day": 65,
    Date: "2025-05-25T00:00:00.000",
    Day: "Sun",
    Start: "7:30 PM",
    Home: null,
    Away: "Final",
    Venue: "Kolkata",
  },
];
